import {
  IsString,
  IsNumber,
  IsOptional,
  IsDefined,
  IsIn,
  IsObject,
  ValidateNested,
  Min,
} from 'class-validator';
import { Type } from 'class-transformer';
import { IsRgbaOrReference } from '@builder4/shared/dto/styles/validators/IsRgbaOrReference';
import {
  VisibilityStateDto,
  SHADOW_TYPE_VALUES,
  type ShadowType,
  ShadowSettingsDto,
} from '@builder4/shared/dto/craft/props/shared';
import { IsTRBLNumberCoords } from '@builder4/shared/dto/craft/validators/IsTRBLNumberCoords';
import { RgbaDto } from '@builder4/shared/dto/styles';

export class ClickTriggerConfigDto {}

export class ExitTriggerConfigDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  pageTime?: number;
}

export class DelayTriggerConfigDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  delay?: number;
}

export class TriggerSettingsDto {
  @IsOptional()
  @IsObject()
  click?: ClickTriggerConfigDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => ExitTriggerConfigDto)
  exit?: ExitTriggerConfigDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => DelayTriggerConfigDto)
  delay?: DelayTriggerConfigDto;
}

export class PopupBreakpointPropsDto {
  @IsOptional()
  @IsString()
  width?: string;

  @IsOptional()
  @IsString()
  height?: string;

  @IsOptional()
  @IsNumber()
  maxWidth?: number;

  @IsOptional()
  @IsTRBLNumberCoords()
  borderRadius?: [number, number, number, number];

  @IsOptional()
  @IsTRBLNumberCoords()
  padding?: [number, number, number, number];

  @IsOptional()
  @IsRgbaOrReference()
  popupColor?: RgbaDto | string | null;

  @IsOptional()
  @IsRgbaOrReference()
  borderColor?: RgbaDto | string | null;

  @IsOptional()
  @IsRgbaOrReference()
  overlayColor?: RgbaDto | string | null;

  @IsOptional()
  @IsNumber()
  @Min(0)
  borderWidth?: number;

  @IsOptional()
  @IsIn([...SHADOW_TYPE_VALUES])
  shadowType?: ShadowType;

  @IsOptional()
  @ValidateNested()
  @Type(() => ShadowSettingsDto)
  shadowSettings?: ShadowSettingsDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => TriggerSettingsDto)
  triggers?: TriggerSettingsDto;
}

export class PopupPropsDto {
  @IsDefined()
  @IsString()
  width!: string;

  @IsDefined()
  @IsString()
  height!: string;

  @IsDefined()
  @IsNumber()
  maxWidth!: number;

  @IsDefined()
  @IsTRBLNumberCoords()
  borderRadius!: [number, number, number, number];

  @IsDefined()
  @IsTRBLNumberCoords()
  padding!: [number, number, number, number];

  @IsDefined()
  @IsRgbaOrReference()
  popupColor!: RgbaDto | string | null;

  @IsDefined()
  @IsRgbaOrReference()
  borderColor!: RgbaDto | string | null;

  @IsDefined()
  @IsRgbaOrReference()
  overlayColor!: RgbaDto | string | null;

  @IsDefined()
  @IsNumber()
  @Min(0)
  borderWidth!: number;

  @IsDefined()
  @IsIn([...SHADOW_TYPE_VALUES])
  shadowType!: ShadowType;

  @IsOptional()
  @ValidateNested()
  @Type(() => ShadowSettingsDto)
  shadowSettings?: ShadowSettingsDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => TriggerSettingsDto)
  triggers!: TriggerSettingsDto;

  @IsDefined()
  @ValidateNested()
  @Type(() => VisibilityStateDto)
  visibility!: VisibilityStateDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PopupBreakpointPropsDto)
  tablet?: PopupBreakpointPropsDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PopupBreakpointPropsDto)
  mobile?: PopupBreakpointPropsDto;
}
